import { render, staticRenderFns } from "./ModalVinculosContatos.vue?vue&type=template&id=f0508ece&"
import script from "./ModalVinculosContatos.vue?vue&type=script&lang=js&"
export * from "./ModalVinculosContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports